import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { CognitoUserPool, CognitoUserAttribute } from 'amazon-cognito-identity-js';
import { POOL_DATA } from "../../../utils/config"
import { message, Tooltip, Input, Select } from 'antd';

import ResetPwd from './ResetPwd';
import Confirm from './Confirm';
import './Account.css';

class Account extends Component {

  state = {
    inputDisplay: false,
    buttonDisplay: 'none',
    oldUserName: 'NOT SET',
    userName: 'NOT SET',
    email: 'NOT SET',
    phone: 'NOT SET',
    oldPhone: 'NOT SET',
    oldPassword: '',
    newPassword: '',
    resetPwdVisible: false,
    phoneToolTip: <span className="Tooltip">CLICK TO SET</span>,
    phoneInputDisplay: false,
    prefix: '+1',
    confirmVisible: false,
  };

  componentDidMount() {
    this.getUserInfo();
  }

  getUserInfo = () => {
    const userPool = new CognitoUserPool(POOL_DATA);
    const cognitoUser = userPool.getCurrentUser();

    if (cognitoUser !== null) {
      cognitoUser.getSession((err, session) => {
        if (err) {
          message.error('The session has expired, please login again');
          this.props.history.push('/login');
          return;
        }
        if (session.isValid() === true) {
          cognitoUser.getUserAttributes((err, result) => {
            if (err) {
              message.error(String(err).split(': ')[1]);
              return;
            }
            this.setState({
              username: cognitoUser.getUsername(),
            });

            const attributeMap = {};

            for (let i = 0; i < result.length; i++) {
              attributeMap[result[i].getName()] = result[i].getValue();
              if (result[i].getName() === 'preferred_username') {
                this.setState({
                  userName: result[i].getValue(),
                  oldUserName: result[i].getValue(),
                })
              }
            }
            if (attributeMap['phone_number_verified'] === 'true') {
              this.setState({
                phone: attributeMap['phone_number'],
                oldPhone: attributeMap['phone_number'],
                phoneToolTip: '',
                phoneInputDisplay: false,
              });
            }
            this.setState({
              email: attributeMap['email'],
            });
          });
        } else {
          message.error('The session has expired, please login again');
          this.props.history.push('/login');
        }
      });
    } else {
      message.error('The session has expired, please login again');
      this.props.history.push('/login');
    }
  };

  handleSetUserName = () => {
    this.setState({
      inputDisplay: true,
      buttonDisplay: 'inline-block',
    });
    if (this.state.userName === 'NOT SET') {
      this.setState({
        userName: '',
      });
    }
  };

  handleCancelSetUserName = () => {
    this.setState({
      inputDisplay: false,
      buttonDisplay: 'none',
      userName: this.state.oldUserName,
    });
  };

  handleSubmitUserName = () => {
    if (this.state.userName.indexOf(" ") !== -1 || this.state.userName.length > 20) {
      message.error('Your username should be contains NO SPACE and LESS THAN 20 CHARACTER');
      return;
    }
    this.setState({
      buttonDisplay: 'none',
      inputDisplay: false,
    });

    if (
      this.state.userName !== this.state.oldUserName
      && this.state.userName !== 'NOT SET'
      && this.state.userName !== ''
    ) {
      const userPool = new CognitoUserPool(POOL_DATA);
      const cognitoUser = userPool.getCurrentUser();
      const attributeList = [];
      const dataUserName = {
        Name: 'preferred_username',
        Value: this.state.userName,
      };

      const attributeUserName = new CognitoUserAttribute(dataUserName);
      attributeList.push(attributeUserName);

      if (cognitoUser !== null) {
        cognitoUser.getSession((err, session) => {
          if (err) {
            message.error(String(err).split(': ')[1]);
            return;
          }
          if (session.isValid() === true) {
            cognitoUser.updateAttributes(attributeList, (err, result) => {
              if (err) {
                message.error(String(err).split(': ')[1]);
                this.setState({
                  userName: this.state.oldUserName,
                });
                return;
              }
              message.success('You have successfully updated your username');
              this.getUserInfo();
            });
          } else {
            message.error('The session has expired, please login again');
            this.props.history.push('/login');
          }
        });
      } else {
        message.error('The session has expired, please login again');
        this.props.history.push('/login');
      }
    }
  };

  handleChange = (e) => {
    this.setState({
      userName: e.target.value,
    })
  };

  handleModifyPassword = () => {
    this.setState({
      resetPwdVisible: true,
    });
  };

  setVisible = () => {
    this.setState({
      resetPwdVisible: false,
    });
  };




  handleSetPassword = () => {
    if (this.state.phone === 'NOT SET') {
      this.setState({
        phoneInputDisplay: true,
      });
    }
  };

  handleChangePhone = (e) => {
    if (e.target.value.lastIndexOf('-') > 0) {
      message.error('Pure number, No Symbol')
    }
    this.setState({
      phone: e.target.value,
    })
  };

  handleSubmitPhone = () => {
    if (this.state.phone !== 'NOT SET') {
      const userPool = new CognitoUserPool(POOL_DATA);
      const cognitoUser = userPool.getCurrentUser();
      const attributeList = [];
      const dataPhoneNumber = {
        Name: 'phone_number',
        Value: this.state.prefix + this.state.phone,
      };

      const attributePhoneNumber= new CognitoUserAttribute(dataPhoneNumber);
      attributeList.push(attributePhoneNumber);

      if (cognitoUser !== null) {
        cognitoUser.getSession((err, session) => {
          if (err) {
            message.error(String(err).split(': ')[1]);
            return;
          }
          if (session.isValid() === true) {
            cognitoUser.updateAttributes(attributeList, (err, result) => {
              if (err) {
                message.error(String(err).split(': ')[1]);
                this.setState({
                  phone: this.state.oldPhone,
                });
                return;
              }
              cognitoUser.getAttributeVerificationCode('phone_number', {
                onSuccess: (result) => {
                  this.setState({
                    confirmVisible: true,
                  })
                },
                onFailure: (err) => {
                  message.error(String(err).split(': ')[1]);
                }
              })
            });
          } else {
            message.error('Please Login.');
          }
        });
      }
    }
  };

  handleCancelSetPhone = () => {
    this.setState({
      phoneInputDisplay: false,
      phone: this.state.oldPhone,
    });
  };

  handleChangePrefix = (e) => {
    this.setState({
      prefix: e,
    })
  };

  setConfirmVisible = () => {
    this.setState({
      confirmVisible: false,
    })
  };

  render() {

    const prefixSelector = (
      <Select
        value={this.state.prefix}
        onChange={this.handleChangePrefix}
      >
        <Select.Option value="1">+1</Select.Option>
      </Select>
    );

    return (
      <div className='Account'>
        <h2>Account details</h2>
        <ResetPwd visible={this.state.resetPwdVisible} setVisible={this.setVisible.bind(this)} key={Math.random()}/>
        <Confirm
          visible={this.state.confirmVisible}
          setConfirmVisible={this.setConfirmVisible.bind(this)}
          getUserInfo={this.getUserInfo.bind(this)}
          key={Math.random()}
        />
        <div className="Form">
          <div>
            <span className="Username">
              <span className="Label">Username</span>
              <Tooltip title={<span className="Tooltip">CLICK TO MODIFY</span>} trigger="hover click">
                <span
                  onClick={this.handleSetUserName}
                  className="hover"
                  style={{display: !this.state.inputDisplay ? 'inline-block' : 'none'}}
                >
                  {this.state.userName}
                </span>
              </Tooltip>
              <Input
                type="text"
                value={this.state.userName}
                onChange={this.handleChange}
                style={{
                  border: '0 none',
                  display: this.state.inputDisplay ? 'inline-block' : 'none',
                }}
              />
              <span className="buttons" style={{display: this.state.buttonDisplay}}>
                <button className="Confirm" onClick={this.handleSubmitUserName}>CONFIRM</button>
                <button className="Cancel" onClick={this.handleCancelSetUserName}>CANCEL</button>
              </span>
            </span>
            <span className="Password">
              <span className="Label">Password</span>
              <Tooltip title={<span className="Tooltip">CLICK TO MODIFY</span>} trigger="hover click">
                <span className="star" onClick={this.handleModifyPassword}><span>************</span></span>
              </Tooltip>
            </span>
          </div>
          <div>
            <span className="Phone">
              <span className="Label">Phone</span>
              <Tooltip
                title={this.state.phoneToolTip}
                trigger="hover click"
              >
                <span
                  className="Text"
                  onClick={this.handleSetPassword}
                  style={{display: !this.state.phoneInputDisplay ? 'inline-block' : 'none'}}
                >
                  {this.state.phone}
                </span>
              </Tooltip>
              <Input
                ref="phoneNumberInput"
                type="number"
                value={this.state.phone}
                onChange={this.handleChangePhone}
                style={{
                  border: '0 none',
                  display: this.state.phoneInputDisplay ? 'inline-block' : 'none',
                }}
                addonBefore={prefixSelector}
              />
              <span
                className="buttons"
                style={{ display: this.state.phoneInputDisplay ? 'inline-block' : 'none' }}
              >
                <button className="Confirm" onClick={this.handleSubmitPhone}>CONFIRM</button>
                <button className="Cancel" onClick={this.handleCancelSetPhone}>CANCEL</button>
              </span>
            </span>
            <span className="Email">
              <span className="Label">Email</span>
              <span className="Text">{this.state.email}</span>
            </span>
          </div>
        </div>
      </div>
    )
  }
}

export default withRouter(Account);



// WEBPACK FOOTER //
// ./src/Containers/Profile/components/Account.js